import { api } from "./api";
import { PartnerBranding, PartnerBrandingResponse } from "app/types/services/branding";

// Never let a slow branding call hold up the checkout for long.
const BRANDING_TIMEOUT_MS = 3000;

export async function fetchPartnerBranding(partnerId?: string | null): Promise<PartnerBranding | null> {
  try {
    const res = await api.get<PartnerBrandingResponse>("portal/assets", {
      params: partnerId ? { partnerId } : undefined,
      timeout: BRANDING_TIMEOUT_MS,
    });

    return res.data?.success ? (res.data.data ?? null) : null;
  } catch (err) {
    console.error("Failed to fetch partner branding:", err);
    return null;
  }
}
